module.exports = __webpack_public_path__ + "static/triangle-b2758f6b75241fff250ab5d115e77b47.png";